import TextElement from '../elements/TextElement'
// import CarouselElement from './CarouselElement'
import ImageElement from '../elements/ImageElement'
import ElementType from '../constants/ElementType'
// import { createLine } from '../services/ElementsService'

import constructorService from '../services/ConstructorService'

class ElementFactory {
  static create(type, data) {
    switch (type) {
      case ElementType.Text:
        return TextElement(data);
      case ElementType.Image:
        return ImageElement(data);
      case ElementType.Line:
        return constructorService.createLine(data.content);
      default:
        throw new Error('Invalid element type: ' + type);
    }
  }
}

export default ElementFactory